module.exports = __webpack_public_path__ + "static/img/scanicon.bf6a8ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report2023/scanicon.png
// module id = 0HGJ
// module chunks = 215